const cartNavButtons = document.querySelectorAll(".Cart_Navigation_Item");
let currentStep = "cart-step-one";

// Setup cart actions and events
document.addEventListener("DOMContentLoaded", () => {
  const toggleCartButtons = document.querySelectorAll(
    '*[data-action="cart-toggle"]'
  );

  toggleCartButtons.forEach((button) => {
    registertoggleCartButton(button);
  });

  function registertoggleCartButton(button) {
    const overlay = button
      .closest(".Cart_Drawer_Section")
      ?.querySelector(".Overlay");
    button.dataset.registered = true;
    button.addEventListener("click", (e) => {
      e.preventDefault();
      // Dispatch event to open cart
      window.dispatchEvent(new CustomEvent("cart:toggle"));
    });
    if (!overlay) return;
    overlay.addEventListener("click", (e) => {
      if (e.target === overlay) {
        window.dispatchEvent(new CustomEvent("cart:toggle"));
      }
    });
  }

  const addCartButtons = document.querySelectorAll('[data-action="cart-add"]');
  const addCartDummy = document.querySelector('[data-action="cart-dummy"]');

  addCartDummy.addEventListener("click", (e) => {
    e.preventDefault();
  });

  addCartButtons.forEach((button) => {
    registerAddCartButton(button);
  });

  function registerAddCartButton(button) {
    button.dataset.registered = true;
    button.addEventListener("click", (e) => {
      e.preventDefault();
      const form = button.closest("form");

      const quantity = Number.parseInt(
        form.querySelector('input[name="quantity"]').value
      );

      let items = [];

      const sellingPlanInput = form.querySelector('input[name="selling_plan"]');
      const sellingPlan = sellingPlanInput ? sellingPlanInput.value : null;

      // const sellingPlanInput = form.querySelector('input[name="selling_plan"]:checked');
      // const sellingPlan = sellingPlanInput ? sellingPlanInput.value : null;

      const customProperties = form.querySelectorAll(
        'select[name*="properties"]'
      );

      if (customProperties.length == 0) {
        items.push({
          id: form.querySelector('input[name="id"]').value,
          quantity: quantity,
          ...(sellingPlan && { selling_plan: sellingPlan }), // Include selling_plan if available
        });
      } else {
        items.push({
          id: form.querySelector('input[name="id"]').value,
          quantity: quantity,
          properties: {
            _Id: crypto.randomUUID(),
          },
          ...(sellingPlan && { selling_plan: sellingPlan }), // Include selling_plan if available
        });
      }

      let priceAdd = 0;

      customProperties.forEach((property) => {
        const key = property.name.split("[")[1].split("]")[0];
        if (property.value == key) return;
        const value = property.value;
        items[0].properties[key] = value;

        let options = property.querySelectorAll("option");
        options.forEach((option) => {
          if (option.value == value) {
            priceAdd += Number.parseFloat(option.dataset.priceAdd);
            items.push({
              id: option.dataset.variantId,
              quantity: 1,
              properties: {
                _Hidden: true,
                _ParentId: items[0].properties["_Id"],
              },
            });
            return;
          }
        });
      });

      if (priceAdd > 0) {
        items[0].properties["_Price Add"] = priceAdd;
      }

      let formData = {
        items: items,
      };

      const body = JSON.stringify(formData);

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: body,
      })
        .then((res) => res.json())
        .then((json) => {
          window.dispatchEvent(new CustomEvent("cart:open"));
          window.dispatchEvent(new CustomEvent("quickview:close"));
        });
    });
  }

  const removeItemButtons = document.querySelectorAll(
    '*[data-action="remove-cart-item"]'
  );

  removeItemButtons.forEach((button) => {
    registerRemoveItemButtons(button);
  });

  function registerRemoveItemButtons(button) {
    button.dataset.registered = true;
    button.addEventListener("click", (e) => {
      e.preventDefault();
      const key = button.closest(".Cart_Item, .Cart_Item_Reward").dataset.key;
      button.closest(".Cart_Item, .Cart_Item_Reward").style.display = "none";

      if (button.dataset.reward == "true") {
        let refuses = [];
        try {
          const refusesStr = localStorage.getItem("refuses");
          if (refusesStr) {
            refuses = JSON.parse(refusesStr);
          }
        } catch (e) {
          refuses = [];
        }
        const itemId = button.closest(".Cart_Item, .Cart_Item_Reward").dataset
          .id;
        if (itemId && !refuses.includes(itemId)) {
          refuses.push(itemId);
          try {
            localStorage.setItem("refuses", JSON.stringify(refuses));
          } catch (e) {
            // ignore
          }
        }
      }

      fetch(`/cart/change?id=${key}&quantity=0`, {
        method: "POST",
      }).then((res) => {
        if (res.status != 200) {
          button.closest(".Cart_Item").style.display = "block";
        }
        window.dispatchEvent(new CustomEvent("cart:update"));
      });
    });
  }

  const stepButtons = document.querySelectorAll("*[data-step]");

  stepButtons.forEach((button) => {
    button.dataset.registered = true;
    button.addEventListener("click", (e) => {
      e.preventDefault();
      const step = button.dataset.step;
      scrollToStep(step);
    });
  });

  window.addEventListener("global:align", function () {
    const newToggleCartButtons = document.querySelectorAll(
      '*[data-action="cart-toggle"]:not([data-registered])'
    );
    const newAddCartButtons = document.querySelectorAll(
      '*[data-action="cart-add"]:not([data-registered])'
    );
    const newRemoveItemButtons = document.querySelectorAll(
      '*[data-action="remove-cart-item"]:not([data-registered])'
    );
    const newStepButtons = document.querySelectorAll(
      "*[data-step]:not([data-registered])"
    );

    newRemoveItemButtons.forEach((button) => {
      registerRemoveItemButtons(button);
    });

    newToggleCartButtons.forEach((button) => {
      registertoggleCartButton(button);
    });
    newAddCartButtons.forEach((button) => {
      registerAddCartButton(button);
    });

    newStepButtons.forEach((button) => {
      button.dataset.registered = true;
      button.addEventListener("click", (e) => {
        e.preventDefault();
        const step = button.dataset.step;
        scrollToStep(step);
      });
    });
  });
});

// Setup listeners
const cartDrawer = document.querySelector("#Cart_Drawer");

window.addEventListener("cart:toggle", function (e) {
  toggleCart();
});

window.addEventListener("cart:open", async function (e) {
  await updateCart(); // First update cart
  cartDrawer.classList.add("Open");
  window.dispatchEvent(new CustomEvent("confirm:close"));
});

async function toggleCart() {
  if (cartDrawer.classList.contains("Open")) {
    cartDrawer.classList.remove("Open");
    return;
  }

  await updateCart(); // First update cart
  cartDrawer.classList.add("Open");
  window.dispatchEvent(new CustomEvent("confirm:close"));
}

/**
 * Cart API
 */

const CART_DRAWER_ID = "cart-drawer";
window.CANDYRACK_CAN_OPEN = false; // Disable checkout until Zapiet delivery date is selected

window.addEventListener("cart:update", updateCart);

document.addEventListener("DOMContentLoaded", function () {
  window.ZapietEvent.listen("widget_loaded", function (e) {
    window.dispatchEvent(new CustomEvent("global:align"));
  });

  window.ZapietEvent.listen("checkoutEnabled", function (e) {
    window.CANDYRACK_CAN_OPEN = true;
    document
      .querySelectorAll(".Cart_Drawer_Content .Checkout_Button")
      .forEach((btn) => {
        btn.classList.remove("cr-ignore");
      });
  });

  const cartForm = cartDrawer.querySelector("form");
  cartForm.addEventListener("submit", (e) => {
    e.preventDefault();
  });
});

const clickEvent = new MouseEvent("click", {
  view: window,
  bubbles: true,
  cancelable: true,
});

setTimeout(() => {
  if (window.location.pathname.includes("/cart")) {
    // change location to home page to refresh cart
    window.location.href = "/#cart";
    // window.location.reload();
    return;
  } else if (window.location.hash == "#cart") {
    document.querySelector('[data-action="cart-toggle"]').click();
    return;
  }
}, 500);

async function updateCart(e) {
  const cart = await getCart();

  const length = cart.item_count;
  console.log(cart, cart.total_price);

  let projectedPrice = cart.total_price;

  cart.items.forEach((item) => {
    if (item.properties && item.properties["Origin"] == "Reward") {
      projectedPrice -= item.final_price;
    }
  });

  const otherChanges = applyRewardCartModifier(cart.items, projectedPrice);

  if (otherChanges) {
    // If there are changes to the cart, we need to update it again
    return;
  }

  const redDot = document.querySelector(".Cart_Has-Items");
  if (length > 0) {
    if (!redDot) {
      const cartLink = document.querySelector("#Cart_Container");
      const newDot = document.createElement("span");
      newDot.className = "Cart_Has-Items";
      newDot.textContent = length;
      cartLink.appendChild(newDot);
    } else {
      redDot.textContent = length;
    }
  } else if (redDot) {
    redDot.remove();
  }

  await cleanExtras(cart);

  // call cart-drawer section using section api
  const cartSectionJSON = await getCartSection();
  const html = cartSectionJSON[CART_DRAWER_ID];

  // parse the html
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  const cartSection = doc.querySelector(".Cart_Drawer_Content");
  const addItems = cartSection.querySelector(".Cart_Drawer_Delivery");

  let keptDate = false;

  // Update cart drawer
  const drawer = cartDrawer.querySelector(".Cart_Drawer_Content");
  // drawer.innerHTML = cartSection.innerHTML;
  if (
    addItems &&
    addItems.querySelector(".Delivery_Title") &&
    drawer.querySelector("#storePickupApp") &&
    drawer.querySelector(".Delivery_Title")
  ) {
    keptDate = true;
    addItems.removeChild(addItems.querySelector(".Delivery_Title"));
    addItems.removeChild(addItems.querySelector("#storePickupApp"));
    addItems.insertBefore(
      drawer.querySelector("#storePickupApp"),
      addItems.firstChild
    );
    addItems.insertBefore(
      drawer.querySelector(".Delivery_Title"),
      addItems.firstChild
    );
  }

  cartDrawer.querySelector(".Cart_Drawer_Content").replaceWith(cartSection);
  cartDrawer
    .querySelector(".Cart_Free_Shipping")
    .replaceWith(doc.querySelector(".Cart_Free_Shipping"));

  scrollToStep(currentStep, true);

  const buttonSection = cartDrawer.querySelector(
    "#cart-step-two .Cart_Drawer_Footer"
  );

  const dateSelectBtn = cartDrawer.querySelector(".checkoutMethodsContainer");
  if (dateSelectBtn) {
    dateSelectBtn.addEventListener("click", (e) => {
      // remove clicked elem
      dateSelectBtn.remove();
    });
  }

  const alertSection = cartDrawer.querySelector("#storePickupApp");
  const scrollSection = cartDrawer.querySelector(".Cart_Items");

  scrollSection.scrollTop = 0;

  const checkoutBtns = buttonSection.querySelectorAll(".Checkout_Button");
  checkoutBtns.forEach((btn) => {
    if (!window.CANDYRACK_CAN_OPEN) {
      btn.classList.add("cr-ignore");
    }

    btn.addEventListener("click", (e) => {
      if (btn.classList.contains("cr-ignore")) {
        e.preventDefault();
        e.stopPropagation();

        setTimeout(() => {
          if (!alertSection.querySelector("p.error")) {
            const error = document.createElement("p");
            error.classList.add("error");
            error.textContent = "Please select a delivery option";
            alertSection.appendChild(error);
          }
        }, 50);
      }
    });
  });

  // Listen for changes in the cart drawer to apply the same logic to duplicated buttons
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        const newCheckoutBtns = Array.from(mutation.addedNodes).filter(
          (dom) =>
            dom.nodeType == 1 && dom.classList.contains("Checkout_Button")
        );
        newCheckoutBtns.forEach((btn) => {
          if (!window.CANDYRACK_CAN_OPEN) {
            btn.classList.add("cr-ignore");
          }

          btn.addEventListener("click", (e) => {
            if (!window.CANDYRACK_CAN_OPEN) {
              e.preventDefault();
              e.stopPropagation();
              setTimeout(() => {
                if (!alertSection.querySelector("p.error")) {
                  const error = document.createElement("p");
                  error.classList.add("error");
                  error.textContent = "Please select a delivery option";
                  alertSection.appendChild(error);
                }
                scrollSection.scrollTop = 0;
              }, 50);
            }
          });
          // document.dispatchEvent(new CustomEvent("zapiet:start"));
        });

        if (
          Array.from(mutation.addedNodes).some(
            (node) => node.nodeType == 1 && node.classList.contains("Price")
          )
        ) {
          window.CANDYRACK_CAN_OPEN = false;
          document.querySelectorAll(".Checkout_Button").forEach((btn) => {
            btn.classList.add("cr-ignore");
          });
        }
      }
    });
  });

  observer.observe(buttonSection, { childList: true, subtree: true });

  window.dispatchEvent(new CustomEvent("global:align"));

  if (!keptDate) document.dispatchEvent(new CustomEvent("zapiet:start"));

  handleRefusedRewards();

  setTimeout(() => {
    const calendarBtn = document.querySelector(".checkoutMethodsContainer");
    calendarBtn.addEventListener("click", (e) => {
      scrollSection.scrollTop = 0;
    });
  }, 500);
}

async function cleanExtras(cart) {
  let items = cart.items;
  let orphanExtras = [];
  items.forEach((item) => {
    if (item.properties && item.properties._ParentId) {
      // if cart has no reference to other item with _Id matching _ParentId, then remove this item
      let parentFound = false;
      items.forEach((parent) => {
        if (
          parent.properties._Id &&
          parent.properties._Id == item.properties._ParentId
        ) {
          parentFound = true;
          return;
        }
      });
      if (!parentFound) {
        orphanExtras.push(item.key);
      }
    }
  });

  if (orphanExtras.length > 0) {
    const formData = {
      updates: orphanExtras.reduce((acc, key) => {
        acc[key] = 0;
        return acc;
      }, {}),
    };

    const res = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    if (res.status != 200) {
      console.error("Error removing orphaned extras");
    } else {
      //window.dispatchEvent(new CustomEvent('cart:update'));
    }

    return res;
  } else {
    return;
  }
}

async function getCartSection() {
  return await fetch(`/?sections=${CART_DRAWER_ID}`, {
    method: "GET",
  })
    .then((res) => {
      return res.json();
    })
    .catch((e) => {
      console.error("Error:", e);
    });
}

async function getCart() {
  return await fetch("/cart.js", {
    method: "GET",
  })
    .then((res) => {
      return res.json();
    })
    .catch((e) => {
      console.error("Error:", e);
    });
}

function scrollToStep(id, sudden = false) {
  const hasItems = document.querySelector(".Cart_Items .Cart_Item");
  if (!hasItems && id != "cart-step-one") {
    return;
  }
  const step = document.getElementById(id);

  if (sudden) step.scrollIntoView();
  else step.scrollIntoView({ behavior: "smooth" });

  cartNavButtons.forEach((button) => {
    button.classList.remove("Current");
    if (button.dataset.step == id) {
      button.classList.add("Current");
    }
  });

  currentStep = id;
}

window.addEventListener("DOMContentLoaded", () => {
  filteredCartRewardProducts.forEach((product) => {});
});

function applyRewardCartModifier(cartItems, projectedCartValue) {
  // Get refused product IDs from localStorage
  let refuses = [];
  try {
    const refusesStr = localStorage.getItem("refuses");
    if (refusesStr) {
      refuses = JSON.parse(refusesStr);
    }
  } catch (e) {
    refuses = [];
  }

  // Get or initialize reached product IDs from localStorage
  let reached = [];
  try {
    const reachedStr = localStorage.getItem("reached");
    if (reachedStr) {
      reached = JSON.parse(reachedStr);
    }
  } catch (e) {
    reached = [];
  }

  // Batch reward modifier changes to minimize cart API calls
  const updates = {};
  const itemsToAdd = [];

  filteredCartRewardProducts.forEach((product) => {
    const rewardProduct = cartItems.find(
      (item) =>
        item.id == product.product &&
        item.properties &&
        item.properties.Origin == "Reward"
    );

    // Prevent adding refused products
    const isRefused = refuses.includes(String(product.product));

    // Track reached products regardless of refusal
    if (projectedCartValue >= product.threshold) {
      if (!reached.includes(String(product.product))) {
        reached.push(String(product.product));
      }
    }

    if (rewardProduct && projectedCartValue < product.threshold) {
      // Mark reward product for removal
      updates[rewardProduct.key] = 0;
    }
    if (
      !rewardProduct &&
      projectedCartValue >= product.threshold &&
      !isRefused
    ) {
      // Mark reward product for addition
      if (product.product && typeof product.product !== "undefined") {
        itemsToAdd.push({
          id: product.product,
          quantity: 1,
          properties: {
            Origin: "Reward",
            _Hidden: true,
          },
        });
      }
    }
  });

  // Update reached in localStorage
  try {
    localStorage.setItem("reached", JSON.stringify(reached));
  } catch (e) {
    // ignore
  }

  // Apply removals in one call if needed
  if (Object.keys(updates).length > 0) {
    fetch(`/cart/update.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates }),
    }).then(() => {
      window.dispatchEvent(new CustomEvent("cart:update"));
    });
  }

  // Apply additions in one call if needed
  if (itemsToAdd.length > 0) {
    fetch(`/cart/add.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items: itemsToAdd }),
    })
      .then(() => {
        window.dispatchEvent(new CustomEvent("cart:update"));
      })
      .catch((error) => {
        console.error("Error adding reward products:", error);
      });
  }

  // changes were made return true
  return Object.keys(updates).length > 0 || itemsToAdd.length > 0;
}

// deletes all products with variant id 49856203653437 from cart
/*
fetch("/cart.js")
  .then((res) => res.json())
  .then((cart) => {
    const itemsToRemove = cart.items
      .filter((item) => item.id == "49856203653437")
      .map((item) => item.key);

    if (itemsToRemove.length > 0) {
      const updates = itemsToRemove.reduce((acc, key) => {
        acc[key] = 0;
        return acc;
      }, {});

      fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates }),
      }).then(() => {
        window.dispatchEvent(new CustomEvent("cart:update"));
      });
    }
  });
*/

function handleRefusedRewards() {
  // refused rewards
  const refusesStr = localStorage.getItem("refuses");
  let refuses = [];
  if (refusesStr) {
    try {
      refuses = JSON.parse(refusesStr);
    } catch (e) {
      refuses = [];
    }
  }

  if (refuses.length > 0 && typeof filteredCartRewardProducts !== "undefined") {
    // Find refused products from filteredCartRewardProducts
    const refusedProducts = filteredCartRewardProducts.filter((product) =>
      refuses.includes(String(product.product))
    );

    if (refusedProducts.length > 0) {
      const rewardsContainer = document.createElement("div");
      rewardsContainer.className = "Missing_Rewards";
      rewardsContainer.innerHTML = `
        <h3 class="Title">Available rewards</h3>
        <div class="Rewards_List"></div>
      `;
      const rewardsList = rewardsContainer.querySelector(".Rewards_List");

      refusedProducts.forEach((product) => {
        const itemDiv = document.createElement("div");
        itemDiv.className = "Missing_Reward_Item";
        itemDiv.dataset.id = product.product;
        itemDiv.innerHTML = `<span>${product.title || "Reward"}</span>`;
        itemDiv.addEventListener("click", () => {
          // remove from refuses
          refuses = refuses.filter((id) => id !== String(product.product));
          console.log("Removed refused product:", product.product);
          try {
            localStorage.setItem("refuses", JSON.stringify(refuses));
            // Update the cart to reflect the change
            window.dispatchEvent(new CustomEvent("cart:update"));
            // remove the html element
            itemDiv.remove();
          } catch (e) {
            // ignore
          }
        });
        rewardsList.appendChild(itemDiv);
      });

      // Insert at the top of the cart drawer content
      const cartContent = cartDrawer.querySelector(".Cart_Drawer_Content");
      if (cartContent) {
        cartContent.insertBefore(rewardsContainer, cartContent.firstChild);
      }
    }
  }
}
